<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
  <div class="form-group row">
    <div class="col-md-12">
      <yt-dropdown-picklist
        [ModelName]="'zaposleni'"
        [GetName]="'get'"
        [ModelProperty]="'Prezime,Ime,Jmbg'"
        [GetParameters]="modelData.MainList.GetParameters" 
        formControlName="OsobaID"
        [Label]="'RADNAKNJIZICA.OSOBA.SINGULAR'" 
        [ngClass]="{'is-invalid': submitted && fc.OsobaID.invalid}">
      </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.OsobaID.invalid">
        <span *ngFor="let validation of errorMessages.OsobaID">
          <span class="error-message" *ngIf="fc.OsobaID.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>             
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-12">
      <yt-dropdown-picklist 
        [ModelName]="'orgjed'" 
        [GetName]="'get'" 
        [ModelProperty]="'Naziv'"
        [GetParameters]="modelData.MainList.GetParameters" 
        formControlName="OrgJedID"
        [Label]="'RADNAKNJIZICA.ORGJED.SINGULAR'" 
        [ngClass]="{'is-invalid': submitted && fc.OrgJedID.invalid}">
      </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.OrgJedID.invalid">
        <span *ngFor="let validation of errorMessages.OrgJedID">
          <span class="error-message" *ngIf="fc.OrgJedID.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-12">
      <yt-input [Type]="'text'" 
                [Label]="'RADNAKNJIZICA.NAZIVISEDISTEPOSLODAVCA.SINGULAR'"
                name="numberNaziv_i_sediste_poslodavca" 
                formControlName="naziv_i_sediste_poslodavca"
                [ngClass]="{'is-invalid': submitted && fc.naziv_i_sediste_poslodavca.invalid}"></yt-input>
      <div class="form-error" *ngIf="submitted && fc.naziv_i_sediste_poslodavca.invalid">
        <span *ngFor="let validation of errorMessages.naziv_i_sediste_poslodavca">
          <span class="error-message" *ngIf="fc.naziv_i_sediste_poslodavca.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-6">
      <yt-fw-date-picker-popup
       name="txtOdDatuma"
       formControlName="od_datuma"
       [ngClass]="{'is-invalid' : submitted && fc.od_datuma.invalid}"
       [Label]="'RADNAKNJIZICA.ODDATUMA.SINGULAR'"
       (OnDateSelected)="onOdDatumaChange()"
      >
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.od_datuma.invalid">
        <span *ngFor="let validation of errorMessages.od_datuma">
          <span class="error-message" *ngIf="fc.od_datuma.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-fw-date-picker-popup name="txtDoDatuma" formControlName="do_datuma"
        [ngClass]="{'is-invalid' : submitted && fc.do_datuma.invalid}" [Label]="'RADNAKNJIZICA.DODATUMA.SINGULAR'"
        (OnDateSelected)="onDoDatumaChange()"        
      >
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.do_datuma.invalid">
        <span *ngFor="let validation of errorMessages.do_datuma">
          <span class="error-message" *ngIf="fc.do_datuma.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-6">
      <yt-input
       [Type]="'decimal'"
       [Label]="'RADNAKNJIZICA.PRCANG.SINGULAR'"
       name="decimalprc_ang"
       formControlName="prc_ang"
       [ngClass]="{'is-invalid': submitted && fc.prc_ang.invalid}"
       (OnValueChange)="prc_angChanged()"
      >
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.prc_ang.invalid">
        <span *ngFor="let validation of errorMessages.prc_ang">
          <span class="error-message" *ngIf="fc.prc_ang.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-input [Type]="'number'" [Label]="'RADNAKNJIZICA.NEDFONDSATI.SINGULAR'" name="numberned_fond_sati"
        formControlName="ned_fond_sati" [ngClass]="{'is-invalid': submitted && fc.ned_fond_sati.invalid}"></yt-input>
      <div class="form-error" *ngIf="submitted && fc.ned_fond_sati.invalid">
        <span *ngFor="let validation of errorMessages.ned_fond_sati">
          <span class="error-message" *ngIf="fc.ned_fond_sati.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-4">
      <yt-input [Type]="'number'" 
                [Label]="'RADNAKNJIZICA.STAZGODINA.SINGULAR'" 
                name="numberstaz_godina"
                formControlName="staz_godina" 
                maxlength="4" 
                [ngClass]="{'is-invalid': submitted && fc.staz_godina.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.staz_godina.invalid">
        <span *ngFor="let validation of errorMessages.staz_godina">
          <span class="error-message" *ngIf="fc.staz_godina.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-4">
      <yt-input [Type]="'number'" [Label]="'RADNAKNJIZICA.STAZMESECI.SINGULAR'" name="staz_meseci"
        formControlName="staz_meseci" maxlength="2" [ngClass]="{'is-invalid': submitted && fc.staz_meseci.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.staz_meseci.invalid">
        <span *ngFor="let validation of errorMessages.staz_meseci">
          <span class="error-message" *ngIf="fc.staz_meseci.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-4">
      <yt-input [Type]="'number'" [Label]="'RADNAKNJIZICA.STAZDANA.SINGULAR'" name="numberstaz_dana"
        formControlName="staz_dana" maxlength="2" [ngClass]="{'is-invalid': submitted && fc.staz_dana.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.staz_dana.invalid">
        <span *ngFor="let validation of errorMessages.staz_dana">
          <span class="error-message" *ngIf="fc.staz_dana.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-12">
      <!-- <label>
           <span translate="NOTE.RELIGIOSHOLIDAY"></span>
         </label> -->
    </div>
  </div>
</form>